import { gql } from "@apollo/client";
import { IBanner, ICmsAncillary, ICmsCountry, IFleet, IGender } from "@common/models/CMS";

export interface IMsterData {
  country?: ICmsCountry[];
  englishCountry?: ICmsCountry[];
  fleet?: IFleet[];
  gender?: IGender[];
  banner?: IBanner[];
  ancillary?: ICmsAncillary[];
}

export const MASTER_DATA = gql`
  query MasterData($culture: String!, $status: Status!) {
    country(where: {localization: {culture: $culture}}, status: $status) {
      sortIndex
      guid
      code {
        code
      }
      cover {
        paths
      }
      name
      demonym
      demonymCode
      callingCode
      flagPosition
      travelConditions {
        contentItems {
          __typename
          ... on News {
            displayText
            localization {
              localizationSet
            }
          }
        }
      }
    }
    englishCountry: country(where: {localization: {culture_not: $culture}}, status: $status) {
      code {
        code
      }
      name
      demonym
    }
    fleet(where: {localization: {culture: $culture}}) {
      displayText
      itineraryCode
      code {
        code
      }
    }
    gender(orderBy: {contentItemId: ASC}, where: {localization: {culture: $culture}}) {
      code
      adultCode
      adultTitle
      adultPrefix
      childCode
      childTitle
      childPrefix
    }
    banner(where: {localization: {culture: $culture}}, status: $status) {
      backgroundImage {
        paths
      }
      backgroundColor
      backgroundLargeHeight
      backgroundSmallHeight
      link {
        text
        url
      }
      text {
        html
      }
      type
      closable
      flip
      contentItemId
    }
    ancillary(where: {localization: {culture: $culture}}, status: $status) {
      contentItemId
      __typename
      code {
        code
      }
      icon
      name
      selectForAll
      options {
        contentItems {
          __typename
          ... on KeyValue {
            key
            value
          }
        }
      }
      content {
        contentItems {
          contentItemId
          contentType
        }
      }
    }
  }  
`;
